import { Environment } from "@Models/Environment";

export const METEOMAPS_API_BASE_PATHS: {
  [key in Environment]: string;
} = {
  local: "https://www.dev.srf.ch/meteomap-api",
  dev: "https://www.dev.srf.ch/meteomap-api",
  int: "https://www.int.srf.ch/meteomap-api",
  "pr-preview": "https://www.srf.ch/meteomap-api",
  prod: "https://www.srf.ch/meteomap-api",
};

// Quaxi
export const METEOAPI_BASE_PATHS: {
  [key in Environment]: string;
} = {
  local: "https://srf-meteoapi-test.herokuapp.com/meteoapi",
  dev: "https://srf-meteoapi-test.herokuapp.com/meteoapi",
  int: "https://www.int.srf.ch/meteoapi",
  "pr-preview": "https://www.srf.ch/meteoapi",
  prod: "https://www.srf.ch/meteoapi",
};

export const ARON_API_BASE_PATHS: {
  [key in Environment]: string;
} = {
  local: "https://www.dev.srf.ch",
  dev: "https://www.dev.srf.ch",
  int: "https://www.int.srf.ch",
  "pr-preview": "https://www.srf.ch",
  prod: "https://www.srf.ch",
};
